import * as React from 'react';
import SwitchRow from '../../../core/components/SwitchRow.tsx';
import FieldsConfig from '../FieldsConfig.tsx';

export interface RuleSetting {
    key: string;
    label: string;
    help?: React.ReactNode;
    isActive: boolean;
    isAlwaysShown?: boolean;
    onToggle: (isOn: boolean) => void;
    isDisabled?: boolean;
    field?: React.ReactNode;
}

interface RuleSettingsCardProps {
    title: string;
    settings: RuleSetting[];
    // shown left of the count, e.g. the Support only badge
    badge?: React.ReactNode;
}

// The rule's settings as the field config's advanced settings: the active ones, and a row for the rest
const RuleSettingsCard = ({ title, settings, badge = undefined }: RuleSettingsCardProps) => (
    <FieldsConfig.AdvancedOptions
        title={title}
        badge={badge}
        rows={settings.map((setting) => {
            const hasContent = setting.isActive && !!setting.field;
            return {
                key: setting.key,
                isActive: setting.isActive,
                isAlwaysShown: setting.isAlwaysShown,
                node: (
                    <SwitchRow
                        className={hasContent ? 'rounded-none px-1 pt-1' : 'rounded-none px-4 py-3'}
                        label={setting.label}
                        description={setting.help}
                        value={setting.isActive}
                        onValueChange={setting.onToggle}
                        disabled={setting.isDisabled}
                    >
                        {hasContent && setting.field}
                    </SwitchRow>
                ),
            };
        })}
    />
);

export default RuleSettingsCard;
